import { purpurColorPurple600, purpurColorRed600, purpurColorFunctionalBlack, purpurColorGreen600, } from "@purpurds/tokens/color/variables";
import { CANCELLED, COMPLETE, COMPLETE_WITHOUT_CODE, INCOMPLETE_WITHOUT_CODE, } from "constants/status-codes";
export const getIconColor = (status, isPastDue) => {
    if (status.includes(INCOMPLETE_WITHOUT_CODE) || isPastDue) {
        return purpurColorRed600;
    }
    if (status === CANCELLED) {
        return purpurColorFunctionalBlack;
    }
    if (status === COMPLETE_WITHOUT_CODE || status === COMPLETE) {
        return purpurColorGreen600;
    }
    return purpurColorPurple600;
};
